<template>
  <div id="landing-page">
    <Slider :slideList="slideList" :bannerImg="images.bannerImg"></Slider>
    <div class="landing-page-container">
      <div class="title">Sprouter's calling!!</div>
      <div class="subtitle-block white-block subtitle-white">
        <div class="subtitle">{{ year }} 25sprout Intern Project</div>
      </div>
      <div class="subtitle-block subtitle-blue">
        <div class="subtitle">新芽 {{ year }} 實習生計畫 限時招募中</div>
      </div>
      <div class="arrow" v-scroll-to="'.sections-container'">
        <img :src="images.downArrow" />
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "./landingPage/Slider.vue";

import downArrow from "../static/images/landingPage/down-arrow.png";
import slideMov from "../static/videos/landing-page-mov.mp4";
import bannerImg from "../static/images/landingPage/bannerImg.jpg";
import tenYear from "../static/images/ten-year.jpg";
let slide01 = {
  sources: [slideMov],
};

export default {
  name: "LandingPage",
  components: {
    Slider,
  },
  data: () => {
    return {
      slideList: [slide01],
      images: {
        downArrow,
        bannerImg,
      },
      year:new Date().getFullYear()
    };
  },
};
</script>

<style scoped lang="scss">
@import "../static/styles/palette.scss";

#landing-page {
  height: 100vh;
  background-color: $blue;
  min-height: 550px;

  & .landing-page-container {
    display: flex;
    position: relative;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 5;
    min-height: 550px;
    max-width: 90%;
    margin: 0 auto;

    & .title {
      font-family: "Lobster";
      font-size: 100px;
      text-align: center;
      letter-spacing: 0.8px;
      color: white;
      text-shadow: 5px 5px 0 rgba(255, 255, 255, 0.5);
    }

    & .white-block {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px auto 20px;
      background-color: white;
      width: 550px;
      height: 60px;

      & .subtitle {
        font-family: "Impact", "Roboto";
        font-weight: 900;
        font-size: 26px;
        letter-spacing: 4.5px;
        color: $blue;
      }
    }

    .subtitle {
      font-size: 22px;
      font-weight: bold;
      color: white;
      letter-spacing: 3px;
    }

    .arrow {
      margin-top: 70px;
      cursor: pointer;
    }
  }
}

@media all and (max-width: 960px) {
  #landing-page {
    & .landing-page-container {
      margin: 0 auto !important;
      width: 600px !important;

      & .white-block {
        width: 500px !important;

        & .subtitle {
          font-weight: normal !important;
          font-size: 21px !important;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  #landing-page {
    & .landing-page-container {
      width: 400px;

      & .title {
        font-size: 80px !important;
      }

      & .white-block {
        width: 400px !important;

        & .subtitle {
          font-weight: normal !important;
          font-size: 18px !important;
        }
      }
    }
  }
}

@media all and (max-width: 480px) {
  #landing-page {
    .landing-page-container {
      margin: 0 auto;
      width: auto;

      & .title {
        font-size: 60px !important;
      }
      & .white-block {
        width: 290px !important;
        height: 40px !important;

        & .subtitle {
          font-size: 14px !important;
          letter-spacing: 3px !important;
          font-weight: bold !important;
        }
      }
      & .subtitle {
        font-size: 14px !important;
        letter-spacing: 1.5px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// LandingPage.vue?138638de